var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResumeApplication = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 263,
    viewBox: "0 0 342 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18487_5732)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.897 42.3142C211.417 24.4659 241.021 -2.33999 270.908 0.163491C300.831 2.42858 331.076 33.7646 339.549 69.1724C347.823 104.307 334.29 143.751 311.84 178.696C289.391 213.641 258.26 244.122 214.525 256.627C170.988 269.405 114.884 263.97 76.456 231.17C38.2264 198.644 17.7097 138.515 38.2069 103.767C58.9022 69.2919 120.377 60.1626 165.897 42.3142Z",
    fill: "#FA7B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.755 197.629C263.298 200.986 229.124 204.375 194.938 207.753C166.047 196.543 136.884 186.267 107.57 176.447C103.783 175.177 99.91 173.906 95.9284 173.971C92.8363 174.025 89.8203 174.883 86.8367 175.73C57.8912 184.019 28.9456 192.307 0 200.595C17.1851 148.031 34.0881 96.0003 50.2099 43.7304C78.8301 34.5516 107.971 26.6329 137.253 19.2248C137.253 19.1161 137.253 19.0075 137.426 18.7034C168.412 30.1958 199.397 41.6774 229.623 53.7998C262.756 53.9954 295.911 51.812 327.243 47.7495C315.667 97.4668 305.263 147.466 297.755 197.629Z",
    fill: "#FA7B6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.354 103.012L137.441 19.2341L170.744 30.8995L228.892 53.6999L216.734 98.7704L202.99 156.567L192.417 206.41L145.899 189.442L96.209 173.535L117.354 103.012Z",
    fill: "#F6F6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1685 60.5575C90.3058 58.0374 92.4431 55.5173 94.5804 53.0081C95.9908 54.9634 99.1587 54.0075 100.916 52.3564C102.674 50.7053 104.171 48.4459 106.547 48.0114C110.051 47.3705 112.688 51.0094 115.888 52.5736C120.608 54.8656 126.173 52.4433 131.413 52.4867C134.484 52.5193 137.489 53.41 140.375 54.4637C149.672 57.8636 158.384 62.969 168.04 65.174C173.421 66.4015 179.063 66.7165 184.14 68.8564C187.2 70.1382 189.955 72.0499 192.961 73.4512C197.539 75.5802 202.595 76.4709 207.347 78.1872C212.099 79.9035 216.818 82.7168 218.977 87.2899C219.194 87.757 219.4 88.2784 219.292 88.7781C218.999 90.2879 216.861 90.1793 215.364 90.5595C212.543 91.2764 211.415 94.5895 210.732 97.4137C210.569 98.0654 210.439 98.8367 210.883 99.3472C211.252 99.7708 211.86 99.836 212.424 99.8794C216.568 100.162 221.168 100.292 224.369 97.6418C226.539 95.8386 227.667 93.047 229.663 91.0483C231.66 89.0496 235.489 88.2349 237.453 90.7007C235.554 93.5901 237.193 97.8482 240.22 99.521C243.247 101.194 247.065 100.738 250.201 99.282C253.336 97.8265 255.962 95.5019 258.685 93.362C266.952 86.8554 276.423 81.8804 286.47 78.7738C287.967 78.3067 289.518 77.8831 291.07 78.0786C295.724 78.6543 297.981 84.6829 296.473 89.1257C294.954 93.5684 291.037 96.6859 287.305 99.5319C281.566 103.931 275.816 108.363 270.901 113.664C268.319 116.445 265.965 119.475 262.992 121.832C259.976 124.233 256.363 125.917 253.705 128.73C250.7 131.902 248.682 136.605 244.44 137.605C242.563 138.05 240.578 137.637 238.679 137.963C232.614 139.017 230.379 146.479 229.739 152.616C229.436 155.473 229.219 158.395 229.859 161.198C231.519 168.465 238.56 173.407 240.849 180.511C241.717 183.205 241.63 186.627 239.363 188.3C237.985 189.321 236.162 189.418 234.448 189.484C229.826 189.657 224.987 189.788 220.843 187.746C214.887 184.802 211.806 178.056 210.352 171.561C209.028 165.641 208.67 159.514 209.289 153.485C205.057 151.498 200.175 150.933 195.597 151.9C191.388 152.79 187.091 154.919 182.99 153.594C180.864 152.91 179.15 151.367 177.36 150.042C165.436 141.167 147.665 141.244 135.818 150.205C132.39 152.801 129.352 156.082 125.327 157.581C121.302 159.08 115.769 157.863 114.467 153.768C114.098 152.616 114.109 151.389 114.131 150.172C114.185 145.426 114.239 140.679 114.304 135.932C114.326 134.281 114.304 132.51 113.349 131.163C111.863 129.078 108.847 128.947 106.297 129.23C103.748 129.512 100.927 129.947 98.8441 128.458C96.7611 126.97 97.1082 122.712 99.6686 122.723C94.5912 110.188 74.6071 110.774 67.9457 98.9996C67.3815 98.0003 66.9258 96.8706 67.0669 95.73C67.273 94.1875 68.5098 93.0253 69.215 91.6457C71.3415 87.5289 68.7919 81.6632 72.0033 78.3393C73.0773 77.2313 74.5854 76.6882 75.9741 76.0256C81.3661 73.4295 82.7439 66.9446 88.1685 60.5575Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.764 129.951C131.185 131.8 138.606 133.648 146.028 135.497C150.964 136.727 151.029 123.977 146.806 123.977C136.41 123.977 141.677 113.806 135.994 115.635C132.771 116.672 122.272 123.977 123.764 129.951Z",
    fill: "#F6DE05",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9609 94.6339C96.1158 94.4818 106.054 91.8748 116.1 90.3758C126.146 88.8768 136.8 88.5727 146.054 92.7656C150.188 94.6448 153.898 97.3495 157.424 100.206C161.873 103.802 166.104 107.658 170.085 111.764C173.091 114.86 176.009 118.118 179.622 120.465C186.804 125.125 196.026 125.624 204.423 124.006C212.831 122.387 220.718 118.846 228.758 115.881C231.34 114.925 234.117 114.023 236.797 114.632",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.41 6.41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.08 107.787C160.2 110.807 155.947 116.792 155.014 123.342",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.41 6.41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.927 124.374C195.428 126.416 196.014 128.611 197.044 130.446C198.075 132.282 199.529 133.835 200.918 135.421C206.223 141.461 218.401 146.387 218.369 154.425",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.41 6.41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2637 84.3896C79.6179 90.7224 82.7425 96.7619 86.5397 102.345",
    stroke: "#FA7B6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1989 84.0535C84.4361 89.3217 80.0096 94.8833 75.9629 100.716",
    stroke: "#FA7B6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M210.493 100.16C209.039 98.0205 207.368 95.9783 205.209 94.5662C203.05 93.1541 200.327 92.4372 197.843 93.1432C195.358 93.8384 193.275 96.1521 193.297 98.7374C193.319 100.41 194.154 101.964 195.196 103.278C197.333 105.972 200.685 107.96 204.092 107.547C207.499 107.123 210.526 103.669 210.493 100.16Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.86 56.3223C82.1165 57.2233 80.6513 58.6569 79.9841 60.5426C78.7504 62.81 77.5273 65.0799 76.2935 67.3473C75.6933 68.457 74.8225 69.7271 73.5581 69.6577C72.3359 69.598 71.4317 68.2518 70.2089 68.2923C68.986 68.3328 68.2794 69.6631 67.2659 70.3428C66.3174 70.9818 65.1051 71.0248 63.9659 71.04C60.9249 71.0948 57.884 71.1496 54.8536 71.2068C54.0592 71.2237 53.1533 71.1926 52.6058 70.6201C51.3951 69.348 53.2209 67.3624 54.9428 66.9914C56.6542 66.618 58.8178 66.5053 59.5323 64.8981C60.3403 63.0784 58.4387 60.8885 59.2255 59.0639C59.4171 58.6178 59.7446 58.2587 60.072 57.8997C62.114 55.652 64.1559 53.4042 66.2084 51.1589C67.3867 49.8596 68.7055 48.4814 70.4421 48.1918C71.6462 47.9909 72.866 48.3511 74.0331 48.699C77.979 49.8902 82.5709 51.7101 83.86 56.3223Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0039 107.334C46.0888 106.791 46.794 105.716 47.727 104.944C48.6601 104.173 50.179 103.771 51.0143 104.64C51.329 104.966 51.4809 105.411 51.5785 105.846C52.1318 108.561 50.0705 111.516 47.3473 111.94C45.7525 112.19 43.8973 111.483 43.3223 109.974C42.7364 108.464 44.1143 106.432 45.0039 107.334Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.171 116.825C50.5686 115.153 52.9663 113.469 55.364 111.796C56.4814 112.557 57.447 113.545 58.1848 114.686C62.9909 115.316 67.3089 118.868 68.8386 123.473C69.5004 125.461 69.0014 128.459 66.9075 128.503C66.1047 128.524 65.3886 128.046 64.7051 127.612C61.2008 125.331 57.3928 123.517 53.4111 122.224C51.979 121.757 50.4602 121.322 49.4078 120.236C48.3663 119.161 48.0842 117.173 48.171 116.825Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.451 171.528C160.144 170.583 162.852 171.048 164.273 172.362C167.581 175.422 168.751 172.813 171.758 174.031C173.494 174.737 174.191 177.068 175.916 177.785C179.207 179.153 182.065 176.668 184.233 180.705",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.686 178.914C171.343 177.368 170.927 180.772 173.737 181.956C175.917 183.208 180.622 180.872 182.154 185.293",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M245.338 158.457C246.47 156.879 249.118 156.142 250.961 156.723C255.252 158.075 255.205 155.216 258.443 155.032C260.313 154.929 261.932 156.738 263.797 156.648C267.356 156.478 268.89 153.011 272.562 155.733",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M255.924 161.62C259.484 158.232 260.55 161.487 263.595 161.356C266.099 161.556 269.368 157.434 272.628 160.776",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.015 53.4984C184.646 52.4504 187.378 52.7459 188.877 53.9688C192.367 56.8155 193.375 54.1398 196.451 55.1682C198.227 55.7647 199.067 58.0469 200.832 58.6549C204.202 59.8149 206.902 57.1584 209.313 61.0508",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.651 51.0867C199.205 49.2541 198.999 52.677 201.877 53.6827C204.129 54.7965 208.683 52.1735 210.484 56.4894",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.556 174.927C17.3704 173.164 19.8327 171.941 21.7526 172.163C26.2216 172.681 25.6375 169.883 28.7834 169.091C30.601 168.636 32.5318 170.108 34.347 169.668C37.8103 168.829 38.6643 165.134 42.7839 167.115",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0777 166.619C27.9366 162.619 29.5968 165.616 32.5635 164.912C35.0598 164.636 37.4951 159.97 41.3265 162.637",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M259.729 108.389C261.367 98.1721 239.028 106.767 255.814 117.605C260.952 120.923 262.998 113.975 263.393 110.328",
    stroke: "#FA7B6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.107 20.2688C126.041 72.1694 112.295 123.494 95.9238 173.961",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M228.644 54.6592C214.583 104.909 202.389 155.68 192.104 206.831",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.755 197.629C263.298 200.986 229.124 204.375 194.938 207.753C166.047 196.543 136.884 186.267 107.57 176.447C103.783 175.177 99.91 173.906 95.9284 173.971C92.8363 174.025 89.8203 174.883 86.8367 175.73C57.8912 184.019 28.9456 192.307 0 200.595C17.1851 148.031 34.0881 96.0003 50.2099 43.7304C78.8301 34.5516 107.971 26.6329 137.253 19.2248C137.253 19.1161 137.253 19.0075 137.426 18.7034C168.412 30.1958 199.397 41.6774 229.623 53.7998C262.756 53.9954 295.911 51.812 327.243 47.7495C315.667 97.4668 305.263 147.466 297.755 197.629Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M313.064 66.1795C310.731 64.7847 309.232 62.9359 308.359 60.3593C307.977 59.2455 307.833 58.2706 306.914 58.1741C305.995 58.0776 305.652 59.0013 305.049 60.0164C303.663 62.3509 301.814 63.8529 299.244 64.7327C298.128 65.1144 297.149 65.3679 297.064 66.1809C296.98 66.9939 297.885 67.4454 298.898 68.0506C301.23 69.4454 302.729 71.2943 303.602 73.8708C303.983 74.9893 304.128 75.9642 305.047 76.0608C305.965 76.1573 306.308 75.2335 306.912 74.2184C308.298 71.8839 310.146 70.3819 312.717 69.5021C313.832 69.1205 314.811 68.867 314.896 68.0539C314.982 67.2362 314.076 66.7848 313.064 66.1795Z",
    fill: "#F6F6F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18487_5732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 312,
    height: 263
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165.897 42.3142C211.417 24.4659 241.021 -2.33999 270.908 0.163491C300.831 2.42858 331.076 33.7646 339.549 69.1724C347.823 104.307 334.29 143.751 311.84 178.696C289.391 213.641 258.26 244.122 214.525 256.627C170.988 269.405 114.884 263.97 76.456 231.17C38.2264 198.644 17.7097 138.515 38.2069 103.767C58.9022 69.2919 120.377 60.1626 165.897 42.3142Z",
    fill: "#FA7B6A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18487_5732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.88 214.322C94.9647 216.609 56.3067 286.62 42.6581 311.436C38.9284 318.172 -24.8947 290.2 -15.6115 277.077C-0.105611 255.241 82.0308 200.413 78.8081 171.621C78.3936 167.903 77.0614 164.169 77.8547 160.506C78.648 156.844 82.9716 153.63 86.0681 155.742C85.2855 150.219 91.9193 146.928 97.2807 145.424C100.729 144.459 104.178 143.495 107.503 144.651C115.238 131.479 122.965 118.294 130.7 105.122C131.513 103.731 132.544 102.184 134.14 101.963C136.039 101.686 137.69 103.556 137.936 105.453C138.182 107.351 137.424 109.22 136.701 110.996C130.205 126.98 125.306 143.774 124.246 161.005C123.757 168.875 125.77 178.962 133.496 180.523C144.814 182.804 152.062 163.635 163.339 166.053C166.256 169.083 162.21 173.562 159.222 177.177C148.343 183.429 142.516 196.095 132.021 202.981C125.771 207.082 122.795 212.036 108.88 214.322Z",
    fill: "#F6F6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6061 153.876C97.1434 149.635 101.654 151.048 103.593 152.286L106.764 146.453L107.821 144.332H102.535L97.7773 145.392L90.9053 147.513L86.6763 151.225L86.1482 155.467L84.5619 154.936L80.3329 155.997L77.6903 160.239C77.5141 161.476 77.3731 164.163 78.2189 165.011C79.8048 158.648 83.5051 160.239 86.1482 158.118C87.2054 154.406 91.4344 151.755 94.6061 153.876Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88 214.322C94.9647 216.609 56.3067 286.62 42.6581 311.436C38.9284 318.172 -24.8947 290.2 -15.6115 277.077C-0.105611 255.241 82.0308 200.413 78.8081 171.621C78.3936 167.903 77.0614 164.169 77.8547 160.506C78.648 156.844 82.9716 153.63 86.0681 155.742C85.2855 150.219 91.9193 146.928 97.2807 145.424C100.729 144.459 104.178 143.495 107.503 144.651C115.238 131.479 122.965 118.294 130.7 105.122C131.513 103.731 132.544 102.184 134.14 101.963C136.039 101.686 137.69 103.556 137.936 105.453C138.182 107.351 137.424 109.22 136.701 110.996C130.205 126.98 125.306 143.774 124.246 161.005C123.757 168.875 125.77 178.962 133.496 180.523C144.814 182.804 152.062 163.635 163.339 166.053C166.256 169.083 162.21 173.562 159.222 177.177C148.343 183.429 142.516 196.095 132.021 202.981C125.771 207.082 122.795 212.036 108.88 214.322Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.104 103.153C132.618 102.599 133.177 102.028 133.904 101.832C134.632 101.635 135.569 101.994 135.71 102.725C135.766 103.04 135.679 103.357 135.592 103.674C134.631 106.799 132.944 109.703 130.694 112.082C130.196 112.606 129.509 113.148 128.817 112.921C128.336 112.757 128.035 112.233 127.994 111.724C127.954 111.214 128.11 110.709 128.274 110.227C129.108 107.798 130.214 105.46 131.573 103.278C131.758 102.964 132.068 102.611 132.104 103.153Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.066 169.156C163.782 168.262 163.359 167.426 162.815 166.672C160.187 167.156 157.745 168.61 156.072 170.694C155.519 171.375 155.024 172.283 155.35 173.106C155.489 173.454 155.768 173.733 156.038 174C156.834 174.756 157.668 175.462 158.555 176.109C158.774 176.271 159.014 176.435 159.282 176.483C159.911 176.602 160.473 176.097 160.888 175.617C162.175 174.126 163.216 172.427 163.957 170.599C164.153 170.121 164.322 169.607 164.259 169.105C164.195 168.603 163.819 168.07 164.066 169.156Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.413 143.261C106.67 146.422 104.783 149.507 102.777 152.511",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7582 145.099C95.9023 148.227 94.11 152.313 93.7547 156.54",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4034 155.194C86.0319 157.686 85.6618 160.168 85.2903 162.661",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.266 159.746C222.534 157.791 227.536 154.468 227.536 154.468L243.086 151.147L251.01 157.338L245.219 159.733L228.393 163.138C228.393 163.138 223.046 161.884 220.357 161.34C220.155 161.295 219.944 161.256 219.801 161.104C219.43 160.716 219.858 160.092 220.266 159.746Z",
    fill: "#F6DE05",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.327 154.122L219.302 160.843L227.287 162.928L230.737 162.07C227.93 159.148 227.961 155.554 228.327 154.122Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.633 156.847C223.719 156.383 221.082 158.772 219.752 160.025L219.88 160.948C221.999 161.343 225.845 161.998 224.27 161.465C222.3 160.799 223.525 157.427 223.633 156.847Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53 332.933C312.269 304.647 277.199 227.068 255.696 205.539C250.564 200.401 244.597 195.154 243.491 187.974C243.035 185.02 243.48 182.022 243.871 179.067C244.814 171.963 245.455 164.587 243.296 157.744C242.46 155.105 241.202 152.465 241.484 149.706C241.766 146.947 244.489 144.21 247.071 145.22C249.23 146.056 250.423 149.109 252.723 148.913C253.461 148.848 254.123 148.435 254.709 147.979C258.723 144.829 260.209 139.484 263.236 135.368C266.263 131.251 272.968 128.665 276.179 132.63C277.937 134.814 277.774 138.051 279.358 140.364C281.278 143.156 285.065 143.753 288.168 145.133C291.271 146.512 294.113 150.369 292.041 153.062C296.728 153.106 300.97 157.31 301.078 162.002C304.93 162.458 307.295 166.749 307.349 170.627C307.403 174.516 305.852 178.209 304.995 182C302.651 192.374 295.74 203.456 301.078 212.656C318.296 242.298 352.944 283.862 375.975 307.341C391.258 322.836 329.786 332.442 323.53 332.933Z",
    fill: "#F6F6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.572 207.721C260.655 203.947 245.374 185.627 244.141 180.148V190.223L250.484 200.297L261.056 211.432L276.915 235.823L294.359 268.168L323.433 332.327L328.719 331.267C320.085 306.876 307.363 268.062 304.403 257.033C300.703 243.247 285.901 213.553 270.572 207.721Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53 332.933C312.269 304.647 277.199 227.068 255.696 205.539C250.564 200.401 244.597 195.154 243.491 187.974C243.035 185.02 243.48 182.022 243.871 179.067C244.814 171.963 245.455 164.587 243.296 157.744C242.46 155.105 241.202 152.465 241.484 149.706C241.766 146.947 244.489 144.21 247.071 145.22C249.23 146.056 250.423 149.109 252.723 148.913C253.461 148.848 254.123 148.435 254.709 147.979C258.723 144.829 260.209 139.484 263.236 135.368C266.263 131.251 272.968 128.665 276.179 132.63C277.937 134.814 277.774 138.051 279.358 140.364C281.278 143.156 285.065 143.753 288.168 145.133C291.271 146.512 294.113 150.369 292.041 153.062C296.728 153.106 300.97 157.31 301.078 162.002C304.93 162.458 307.295 166.749 307.349 170.627C307.403 174.516 305.852 178.209 304.995 182C302.651 192.374 295.74 203.456 301.078 212.656C318.296 242.298 352.944 283.862 375.975 307.341C391.258 322.836 329.786 332.442 323.53 332.933Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.998 142.001C261.69 138.608 264.227 138.113 265.284 138.29L265.813 144.653V152.606L264.227 162.681L262.113 167.453L258.941 169.044L256.298 170.104L254.184 165.862V158.439L252.598 150.485L255.769 147.304C256.474 146.95 258.307 145.395 259.998 142.001Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.676 147.251C252.334 150.532 253.831 154.735 253.842 158.95C253.842 160.927 253.538 162.926 253.983 164.848C254.851 168.628 258.323 171.159 261.556 173.288",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.222 138.028C266.676 143.492 265.732 149.249 265.374 154.887C265.178 157.885 265.146 160.981 264.007 163.761C262.868 166.542 260.296 168.997 257.291 168.932",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.688 137.322C279.054 145.002 280.421 152.681 281.788 160.361",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.161 152.237C291.033 156.31 291.119 160.699 292.4 164.729",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.342 161.73C300.418 164.207 300.494 166.695 300.58 169.171",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.897 153.203C241.506 150.9 241.235 148.196 242.895 146.545C243.34 146.11 244.013 145.773 244.577 146.056C244.891 146.208 245.098 146.534 245.271 146.827C246.519 148.924 247.604 151.118 248.515 153.377C248.634 153.67 248.754 153.985 248.699 154.3C248.634 154.702 248.298 155.006 247.994 155.278C247.235 155.941 246.443 156.614 245.499 156.973C244.555 157.331 243.394 157.298 242.624 156.636C241.691 155.821 242.103 154.42 241.897 153.203Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.777 130.496C343.507 134.747 344.877 139.543 338.501 140.867L254.181 157.894L253.126 153.654C252.598 151.534 251.542 149.414 251.542 149.414L339.777 130.496Z",
    fill: "#F6DE05",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.618 130.541C333.19 130.913 331.754 131.292 330.326 131.664C329.805 131.802 329.268 131.954 328.873 132.312C328.326 132.81 328.169 133.591 328.085 134.325C327.815 136.809 328.149 139.341 329.048 141.669C329.314 142.365 329.672 143.069 330.324 143.429C330.888 143.735 331.567 143.719 332.204 143.654C334.704 143.418 337.158 142.699 339.39 141.543C337.501 138.6 336.936 134.835 337.874 131.454C338.022 130.935 338.167 130.292 337.771 129.916C337.466 129.634 337 129.684 336.593 129.755C334.415 130.16 332.338 130.975 334.618 130.541Z",
    fill: "#F0F0E4",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28 130.761C338.927 129.612 342.797 129.198 346.599 129.544C347.487 129.622 348.432 129.78 349.069 130.403C349.598 130.93 349.801 131.694 349.988 132.416C350.385 134.005 350.763 135.808 349.91 137.206C349.204 138.363 347.849 138.919 346.569 139.354C344.278 140.135 341.92 140.75 339.542 141.205C338.005 141.491 336.269 141.667 335.024 140.723C333.939 139.889 333.559 138.435 333.334 137.084C332.992 134.96 332.648 131.589 335.28 130.761Z",
    fill: "#FA7B6A",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18487_5732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 263,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResumeApplication);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/resume-application.d96e5a821231f74f347d7aba1f282536.svg";